import React, { FC } from 'react';
import { ITabsProps } from '../types';
import { StyledTabs, StyledTab } from './styled';

export const Tabs: FC<ITabsProps> = ({ value, onChange, options, orientation, variant, sx }) => {
  return (
    <StyledTabs value={value} onChange={onChange} orientation={orientation} variant={variant} sx={sx}>
      {options !== undefined &&
        options.map((item, index) => (
          <StyledTab
            key={index}
            label={item.label}
            iconPosition={'start'}
            icon={item.icon}
            centerRipple
            badge={item.badge}
          />
        ))}
    </StyledTabs>
  );
};
